import { loginRes } from '../Login/Login.res';

export const res = {
  selectUser: {
    is: 'Veldu aðgang',
    en: 'Select access',
    pl: 'Wybierz dostęp',
  },
  loadingTitle: {
    ...loginRes.loadingTitle,
  },
  loadingDescription: {
    ...loginRes.loadingDescription,
  },
  title: { ...loginRes.login },
};
